<template>
  <div class="row">
    <div class="col s10" style="padding-right: 0px">
      <health-score-graph class="z-depth-1" :healthScoreData="seriesData"></health-score-graph>
    </div>
    <div class="col s2">
      <div class="control col s12 z-depth-1 white">
        <div class="input-field" @change="getData(railObject)">
           {{ $t('analysis.direction') }}:
          <select v-model="r8HealthScoreDirection" class="browser-default">
            <option v-for="direction in ['Normal','Reverse','Both']" :value="direction" :key="direction">
              {{ direction }}
            </option>
          </select>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import R8PointAlarmsService from '@/services/r8/PointAlarmsService'
import HealthScoreGraph from './_healthScoresGraph.vue'
import moment from 'moment'

export default {
  props: {
    railObject: {
      required: true
    },
    timeSelection: Object
  },
  components: {
    'health-score-graph': HealthScoreGraph
  },
  data: function () {
    return {
      seriesData: [],
      r8HealthScoreDateTimeFrom: moment().subtract(1, 'year').format(), // utc date
      r8HealthScoreDateTimeTo: moment().format(), // utc date
      r8HealthScoreDirection: 'Normal', // normal / reverse / both
      r8HealthScoreDays: 2 // nullable object
    }
  },
  created: function () {
    this.getData(this.railObject)
  },
  methods: {
    async getData (asset) {
      this.seriesData = []
      if (this.r8HealthScoreDirection !== 'Both') {
        const result = await this.getR8HealthScores(asset, this.r8HealthScoreDirection)
        this.seriesData.push(result)
      } else {
        const result = await Promise.all([
          this.getR8HealthScores(asset, 'Normal'),
          this.getR8HealthScores(asset, 'Reverse')])
        result.forEach(result => this.seriesData.push(result))
      }

      this.seriesData.push({
        name: 'Unhealthy',
        marker: {
          symbol: 'triangle',
          fillColor: '#dc3545'
        },
        data: [] })
    },
    async getR8HealthScores (asset, direction) {
      const result = await R8PointAlarmsService.getHealthScore(
        asset,
        moment(this.timeSelection.start).format(),
        moment(this.timeSelection.end).format(),
        direction,
        this.r8HealthScoreDays)

      var seriesDataDataPoints = []
      if (result && result[0]) {
        result[0].events.forEach(element => {
          const unhealthy = element.value < 0.95 || element.value > 1.05
          let eventObjectData = {
            x: moment(element.measurementDateTime).valueOf(),
            y: (unhealthy ? (element.value < 0.95 ? 0.95 : 1.05) : element.value),
            marker: {
              symbol: (unhealthy ? (element.value <= 0.95 ? 'triangle-down' : 'triangle') : null),
              fillColor: (unhealthy ? '#dc3545' : null),
              lineColor: '#333',
              lineWidth: 0.8
            }
          }

          seriesDataDataPoints.push(eventObjectData)
        })
      }
      return { name: direction, data: seriesDataDataPoints }
    }
  },
  watch: {
    railObject (val) {
      if (val) {
        this.getData(val)
      }
    },
    timeSelection () {
      this.getData(this.railObject)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/switch/_analysis/HealthScores.vue